import React, { Dispatch, PropsWithChildren, useState } from 'react';
import { ISendMessage } from '../hooks/chatbot/useCBChatMessage';
import { ICustomFlow, IMessage } from '../interfaces/component-interfaces';

interface IChatbotContextState {
  isSendMessageLoading?: boolean;
  discussionId?: string;
  sessionId?: string;
  conversationMessages: IMessage[];
  showHelperButton?: boolean;
  showErrorMessage?: boolean;
  isChatbotEndError?: boolean;
  isSessionExpired?: boolean;

  startChatbotSession?: () => void;
  endChatbotSession?: (data: { escalate?: boolean }) => void;
  sendChatbotMessage?: (messageData: ISendMessage) => void;
  stopChatbotMessage?: () => void;
  retrieveChatbotSession?: () => void;
  endChatData?: string;
  endChatLoading?: boolean;
  orderNumber?: string;
  selectedProductIds?: string[];
  customFlow?: ICustomFlow;
  chatbotFlowRunId?: string;
  flowAttemptCounts?: { [flowType: string]: number };
  isRemediationAvailable?: boolean;
  latestQuery?: string;
}

interface IChatbotContextProps {
  state: IChatbotContextState;
  setState: Dispatch<React.SetStateAction<IChatbotContextState>>;
}

export const ChatbotContext = React.createContext<IChatbotContextProps>({
  state: { conversationMessages: [], latestQuery: '' },
  setState: () => {},
});

const ChatbotProvider: React.FC<PropsWithChildren<IChatbotContextState>> = ({ children, conversationMessages = [], discussionId, sessionId }) => {
  const [state, setState] = useState<IChatbotContextState>({ conversationMessages, discussionId, sessionId, latestQuery: '' });
  return (
    <ChatbotContext.Provider
      value={{
        state,
        setState,
      }}
    >
      {children}
    </ChatbotContext.Provider>
  );
};

export { ChatbotProvider };
